import { INTERFACE_PANEL_TRIGGERS } from '../../../../constants';

export const state = {
    organization: { id: null },
    clickedInRangeForWebfeedback: undefined,
    scales: [],
    uiElements: {
        [INTERFACE_PANEL_TRIGGERS.INFORMATION]: {
            position: 'bottom',
            visible: false,
            focus: false,
            loading: true,
            height: null,
            width: null,
            maxWidth: false,
            active: false,
            components: {
                refreshButton: { visible: false, inactive: true },
                overviewButton: { visible: true },
                detailPanel: { position: 'left', visible: false, resize: null },
                tab: { visible: true },
            }
        },
        [INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH]: {
            position: 'left',
            visible: false,
            resize: null,
            textToSearch: null,
            height: null,
            width: null,
            components: { filter: null }
        },
        [INTERFACE_PANEL_TRIGGERS.FILTERS]: {
            position: 'left',
            visible: false,
            resize: null,
            components: {
                close: { visible: true },
                filters: { list: [] },
            }
        },
        [INTERFACE_PANEL_TRIGGERS.LEGEND]: {
            position: 'left',
            visible: false,
            resize: null
        },
        [INTERFACE_PANEL_TRIGGERS.PRINT]: {
            position: 'top',
            visible: false
        },
        [INTERFACE_PANEL_TRIGGERS.MEASURE_EDIT]: {
            position: 'left',
            visible: false
        },
        [INTERFACE_PANEL_TRIGGERS.FEEDBACK_EDIT]: {
            position: 'right',
            visible: false,
            mode: null,
            contentTypeId: null,
            data: null
        },
        [INTERFACE_PANEL_TRIGGERS.MENU]: {
            position: 'left',
            visible: false,
            resize: null,
            components: {
                legend: {
                    visible: false,
                    icon: 'legend-icon',
                    close: { visible: true },
                    title: 'labelLegend'
                },
                filter: {
                    visible: false,
                    icon: 'filter-icon',
                    title: 'labelFilters'
                },
                welcome: {
                    visible: false,
                    icon: 'welcome-icon',
                    title: 'menuItemWelcomeMessage'
                },
                measure: {
                    visible: false,
                    icon: 'measure-icon',
                    title: 'menuItemMeasurements'
                },
                print: {
                    visible: false,
                    icon: 'print-icon',
                    title: 'labelPrint'
                },
                accessibility: {
                    visible: false,
                    icon: 'accessibility-icon',
                    title: 'accessibility.AccessibilityView'
                }
            }
        },
        [INTERFACE_PANEL_TRIGGERS.WEB_FEEDBACK]: {
            position: 'right',
            visible: false,
            showDrawToolbar: false,
            data: null
        },
        [INTERFACE_PANEL_TRIGGERS.WEB_INFORMATION]: {
            position: 'right',
            visible: false,
            data: null,
            height: null
        },
        menuBar: {
            visible: true,
            components: {
                hamburger: {
                    visible: false,
                    tooltip: 'labelMenu',
                    icon: 'navigation-icon'
                },
                logo: {
                    visible: true,
                    alt: 'logo',
                    imageUrl: ''
                },
                previous: {
                    visible: false,
                    title: '',
                    imageUrl: '',
                    label: ''
                },
                mapControls: {
                    visible: true,
                    components: {
                        search: {
                            visible: false,
                            textToSearch: null,
                            suggestions: null,
                            showResults: true
                        },
                        filter: {
                            visible: false,
                            label: 'labelFilters'
                        }
                    }
                },
                dropdowns: {
                    selectionPanel: {
                        visible: false,
                        features: null,
                        mode: null
                    }
                },
                feedbackControl: { visible: false },
                measureControl: { visible: false },
                selection: {
                    visible: true,
                    title: 'menuItemSelectionMenu'
                },
                feedback: {
                    visible: true,
                    title: 'menuItemFeedbacks'
                },
                measure: {
                    visible: true,
                    title: 'menuItemMeasurements'
                },
                ellipses: { smallDeviceVisible: true }
            }
        },
        [INTERFACE_PANEL_TRIGGERS.BASELAYER]: { resize: null },
        [INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL]: {
            visible: false,
            dontShowAgain: false,
            data: null
        }
    }
};

export default state;
